import React, {useRef} from 'react'
import {useOnScreen} from './useOnScreen'

export const HowTo = ({content}) => {
    const cardsRef = useRef(null)
    const fadeAlready = useOnScreen(cardsRef, 'fade-already')

    return (
        <div className='howto-wrapper'>
            <h1>{content.title}</h1>
            <p className='howto-subtitle'>{content.subtitle}</p>
            <div className={`cards ${fadeAlready}`} ref={cardsRef}>
                {
                    content.cards.map((card, index) =>(
                        <div key={index} className='my-card' style={{animationDelay: `${200*index}ms`}}>
                            <img src={card.img} />
                            <p dangerouslySetInnerHTML={{__html: card.text}} />
                        </div>
                    ))
                }
            </div>
            <div className='howto-bottom'>
            </div>

        </div>
    )
}